import api from './api';

// Description: Register a new user with CAPTCHA validation
// Endpoint: POST /api/auth/register
// Request: { name: string, email: string, password: string, confirmPassword: string, captchaToken: string }
// Response: { success: boolean, message: string, user?: { id: string, name: string, email: string, role: string, isEmailVerified: boolean, createdAt: string } }
export const registerUser = async (data: { name: string; email: string; password: string; confirmPassword: string; captchaToken: string }) => {
  try {
    const response = await api.post('/api/auth/register', data);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Login user with rate limiting and CAPTCHA
// Endpoint: POST /api/auth/login
// Request: { email: string, password: string, captchaToken?: string }
// Response: { success: boolean, message: string, token?: string, user?: { id: string, name: string, email: string, role: string }, requiresCaptcha?: boolean, attemptsLeft?: number, blockedUntil?: string }
export const loginUser = async (data: { email: string; password: string; captchaToken?: string }) => {
  try {
    const response = await api.post('/api/auth/login', data);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Type definitions
export interface User {
  id: string;
  name: string;
  email: string;
  isEmailVerified: boolean;
  role: string;
  createdAt: string;
}

export interface RegisterResponse {
  success: boolean;
  message: string;
  user?: User;
  error?: string;
  captchaFailed?: boolean;
}